import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import messages from './local/index';

const STORAGE_KEY = 'jph_portal_language';
const savedLang = typeof window !== 'undefined' ? (localStorage.getItem(STORAGE_KEY) || 'en') : 'en';

i18n
  .use(initReactI18next)
  .init({
    lng: savedLang,
    fallbackLng: 'en',
    debug: false,
    resources: messages,
    interpolation: {
      escapeValue: false,
      prefix: '{',
      suffix: '}',
    },
    saveMissing: import.meta.env.DEV,
    missingKeyHandler: import.meta.env.DEV
      ? (lngs: readonly string[], ns: string, key: string) => {
          console.warn('[i18n] Missing translation key:', key, 'language:', lngs[0], 'namespace:', ns);
        }
      : undefined,
  });

export default i18n;